import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { removeDefaultParams } from 'src/common/utils'

import { IFilter } from 'src/components/filter/types/filter.types'

interface IProps {
  initialState: IFilter
}

export const useFilter = ({
  initialState,
}: IProps): [IFilter, Dispatch<SetStateAction<IFilter>>] => {
  const state = useState<IFilter>(initialState)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const params = searchParams.toString()
    if (!params) {
      // Convert initialState to Record<string, string> and set as URL parameters
      const initialStateRecord: Record<string, string> = {}
      Object.entries(initialState).forEach(([key, value]) => {
        initialStateRecord[key] = String(value)
      })

      setSearchParams(initialStateRecord)
      state[1](initialState)
      return
    }
    let acc: any = {}
    new URLSearchParams(params).forEach((value, key) => {
      if (acc[key]) {
        if (Array.isArray(acc[key])) {
          return (acc = { ...acc, [key]: [...acc[key], [value]] })
        }

        return (acc = { ...acc, [key]: [acc[key], [value]] })
      }

      return (acc = { ...acc, [key]: [value] })
    })

    const paramsObject = removeDefaultParams(acc, initialState)
    state[1]((prev) => ({ ...prev, ...paramsObject }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setFilter: Dispatch<SetStateAction<IFilter>> = (action: SetStateAction<IFilter>) => {
    if (typeof action === 'function') {
      const result = action(state[0])
      state[1]((prev) => ({ ...prev, ...result }))
      setSearchParams(removeDefaultParams({ ...result }, initialState) as any)
    } else {
      setSearchParams(removeDefaultParams({ ...action }, initialState) as any)
      state[1](action)
    }
  }

  return [state[0], setFilter]
}
